import { render, staticRenderFns } from "./knowledge-index.vue?vue&type=template&id=6032eedb&scoped=true"
import script from "./knowledge-index.vue?vue&type=script&lang=js"
export * from "./knowledge-index.vue?vue&type=script&lang=js"
import style0 from "./knowledge-index.vue?vue&type=style&index=0&id=6032eedb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6032eedb",
  null
  
)

export default component.exports